export default __webpack_public_path__ + "static/media/binance.ea981115.svg";